import { Injectable }           from '@angular/core';
import { CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot }  from '@angular/router';
import {Constant} from "../constant";
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  confirmChangeRouter: (url?) => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  previousState: any;
  exceptList: any = [
    Constant.url_issuer_create_bonds,
    Constant.url_issuer_create_new_fund,
    Constant.url_issuer_create_trading_fund,
    Constant.url_issuer_create_certificate_deposit,
  ]
  canDeactivate(
    component: CanComponentDeactivate,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (nextState.url !== Constant.url_login) {
      let temp = undefined;
      if (!temp) {
        let exist = false;
        this.exceptList.forEach((item) => {
          if ('/'+nextState.url.substring(1, nextState.url.length-1) === item) {
            exist = true;
          }
        })
        !exist && ( temp = nextState.url)
      }
      // this.previousState = nextState.url;
      if (temp && component && component.confirmChangeRouter && component.confirmChangeRouter(nextState.url)) {
        return true;
      } if (!component || (component && !component.confirmChangeRouter)) {
        return true;
      } else {
        // this.previousState = temp;
        return false;
      }
    } else {
      return true;
    }
  }
}
